import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import fetch from '../../utils/fetch';
import { useDispatch } from 'react-redux';
import { addProductsGroup } from '../../store/productsWithGroups';
import PaginationBtn from '../../components/PaginationBtn';
import Product from '../Products/singleproduct';
import Loading from '../../components/Loading';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import icons from '../../utils/icons.json';
import constants from '../../utils/constants.json';
import PriceRange from '../../components/PriceRange';
import SortBy from './SortBy';
import { setBrandsAndColors, sortProducts, filterByBrandsAndColors, isMobile } from '../../utils/fn';
import { Clear, ExpandLess, ExpandMore, Search } from '@mui/icons-material';
import { Button, IconButton, TextField, styled } from '@mui/material';
import { StyledsearchTextField } from '../../utils/muistyles';
import Topsellingcard from '../Products/topsellingcard';
import { Shuffle } from '../../utils/functions';



function Category() {
	useDocumentTitle('Product Categories');

	const dispatch = useDispatch();
	const { item_group, sub_group, categoryCode } = useParams();
	const allProducts = useSelector((state) => state.productsWithGroups);
	const categories = useSelector((state) => state.categories.data);

	const [showcategories, setshowcategories] = useState(true);

	const [brandhint, setbrandhint] = useState('');
	const [groupId, setGroupId] = useState('');
	const [itemGroupName, setItemGroupName] = useState('');
	const [subGroupName, setSubGroupName] = useState('');
	const [subCategoryName, setSubCategoryName] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	const [productsToView, setProductsToView] = useState([]);
	const [viewGroupPosition, setViewGroupPosition] = useState(0);
	const [productGroups, setProductGroups] = useState([]);

	const [topSellingProducts, settopSellingProducts] = useState([]);
	const [displayedbrands, setdisplayedbrands] = useState([]);
	const [brands, setBrands] = useState([]);
	const [colors, setColors] = useState([]);

	const [minPriceRange, setMinPriceRange] = useState(constants.MIN_PRICE);
	const [maxPriceRange, setMaxPriceRange] = useState(constants.MAX_PRICE);

	const [sortBy, setSortBy] = useState('rand');
	const [brandFilters, setBrandFilters] = useState([]);
	const [colorFilters, setColorFilters] = useState([]);

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
		setProductsToView(productGroups[viewGroupPosition] || []);
	}, [viewGroupPosition, productGroups]);


	useEffect(() => {
		if (item_group) {
			let ctg = categories[_.findIndex(categories, { item_group })];
			if (!ctg) return;
			setItemGroupName(_.startCase(ctg.group_name));
			if (sub_group) {
				let group = ctg.subgroups[_.findIndex(ctg.subgroups, { sub_group })];
				if (!group) return;
				setSubGroupName(group.sub_group_name);
				if (categoryCode) {
					let subCtg = ctg.categories[_.findIndex(ctg.categories, { sub_group, categoryCode })];
					if (!subCtg) {
						setSubCategoryName('All');
					} else {
						// we will check if we can request with three subgroups
						setSubCategoryName(subCtg.categoryName);
					}
					setGroupId(item_group + sub_group);
					loadFromSubCategory(item_group, sub_group);
				} else {
					setGroupId(item_group + sub_group);
					loadFromSubCategory(item_group, sub_group);
				}
			} else {
				setGroupId(item_group);
				loadFromCategory(item_group);
			}
		}
	}, [item_group, categories, sub_group, categoryCode]);

	useEffect(() => sortedAndFiltered(), [sortBy, allProducts, groupId, colorFilters, brandFilters, minPriceRange, maxPriceRange]);

	useEffect(() => { loadtopselling() }, []);

	function loadtopselling() {
		fetch
			.get('getTopSellingProducts')
			.then((res) => {
				settopSellingProducts(Shuffle(res.list))
			})
			.catch((err) => {
			});
	}


	function sortedAndFiltered() {
		let filtered = allProducts[groupId];
		if (!filtered) return;
		filtered = filtered.itemsarray;

		setBrandsAndColors(filtered, setBrands, setColors, setdisplayedbrands);

		filtered = filtered.filter((item) => parseFloat(item.itemPrice) >= minPriceRange && parseFloat(item.itemPrice) <= maxPriceRange);
		filtered = filterByBrandsAndColors(filtered, brandFilters, colorFilters);
		filtered = sortProducts(filtered, sortBy);

		setViewGroupPosition(0);
		setProductGroups(filtered);
	}

	function loadFromCategory(ctg) {
		let data = allProducts[ctg];
		setError('');
		if (!data) {
			setLoading(true);
			setProductGroups([]);
			fetch
				.get('getProductsGroup', { group_code: ctg })
				.then((res) => {
					dispatch(addProductsGroup({ category: ctg, data: res.list }));
					setLoading(false);
					//console.log(res.list);
					setError('');
				})
				.catch((err) => {
					setLoading(false);
					setError(err.message);
				});
		} else {
			setProductGroups(_.chunk(data.itemsarray, 30));
		}
	}

	function loadFromSubCategory(ctg, sub) {
		let data = allProducts[ctg + sub];
		setError('');
		if (!data) {
			setLoading(true);
			setProductGroups([]);
			fetch
				.get('filterWithSubGroups', { group_code: ctg, sub_group: sub })
				.then((res) => {
					setLoading(false);
					setError('');
					dispatch(addProductsGroup({ category: ctg + sub, data: res.list }));
				})
				.catch((err) => {
					setLoading(false);
					setError(err.message);
				});
		} else {
			setProductGroups(_.chunk(data.itemsarray, 30));
		}
	}

	function brandFilterAction(val, checked) {
		setBrandFilters((brands) => {
			let arr;
			if (checked) {
				arr = [...brands];
				arr.push(val);
			} else {
				arr = brands.filter((brand) => brand != val);
			}
			return arr;
		});
	}

	function colorFilterAction(val, checked) {
		setColorFilters((colors) => {
			let arr;
			if (checked) {
				arr = [...colors];
				arr.push(val);
			} else {
				arr = colors.filter((color) => color != val);
			}
			return arr;
		});
	}


	const onchangebrand = (text) => {
		setbrandhint(text)
		if (text) {
			const hintLowerCase = text?.toLowerCase().replace(/\s+/g, '');
			setdisplayedbrands(
				brands.filter((element) => {
					const elementname = element.brandName?.toLowerCase().replace(/\s+/g, '');
					return elementname?.includes(hintLowerCase);
				})
			)
		} else {
			setdisplayedbrands(brands)
		}
	}

	const clearsearch = () => {
		setbrandhint('')
		setdisplayedbrands(brands)
	}

	return (
		<div className="main-body categories-body">
			<div className="sub-header">
				<div className="flex">
					<Link to="/">Home</Link>
					<span>{'/'}</span>
					{itemGroupName && item_group && <Link to={`/categories/${item_group}`}>{_.startCase(itemGroupName)}</Link>}
					{subGroupName && sub_group && (
						<>
							<span>{'/'}</span>
							<Link to={`/categories/${item_group}/${sub_group}`}>{_.startCase(subGroupName)}</Link>
						</>
					)}
					{subCategoryName && categoryCode && (
						<>
							<span>{'/'}</span>
							<Link to={`/categories/${item_group}/${sub_group}/${categoryCode}`}>{_.startCase(subCategoryName)}</Link>
						</>
					)}
				</div>
			</div>
			{!sub_group &&
				categories.map((category, index) => {
					if (category.item_group == item_group) {
						if (category.subgroups.length > 0) {
							return (
								<div className="sections sub-categories">
									<div style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid gray", paddingBottom: 3 }}>
										<h3 className="title" style={{ borderRadius: 25, marginTop: 3 }}>Categories</h3>
										<Button endIcon={!showcategories ? <ExpandMore /> : <ExpandLess />} onClick={() => setshowcategories(!showcategories)}>{showcategories ? 'Show less' : 'View all'}</Button>
									</div>
									{showcategories &&
										<div className="body">
											{' '}
											{category.subgroups.map((sub_group, index) => (
												<Link className="link" to={`/categories/${category.item_group}/${sub_group.sub_group}`} key={category.item_group + sub_group.sub_group + index}>
													{_.startCase(sub_group.sub_group_name)}
													<span dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
												</Link>
											))}
										</div>
									}
								</div>
							);
						}
						return '';
					}
				})}
			{error && (
				<div className="sections" style={{ padding: '20px' }}>
					<h3>Error!!</h3>
					<p>{error}</p>
				</div>
			)}
			{!loading && !error && !productGroups && (
				<p className="sections" style={{ padding: '10px 10px 200px' }}>
					Products for the category you selected is currently not available. Keep checking for updates or visit other categories available.
				</p>
			)}
			{
				<div className="products-category">
					<div className="sub-menu sections">
						<div className="listing">
							<h4>Brand</h4>
							<StyledsearchTextField
								placeholder="Search brand"
								variant="outlined"
								value={brandhint}
								onChange={(e) => onchangebrand(e.target.value)}
								InputProps={{
									endAdornment: <IconButton onClick={() => clearsearch()}> {brandhint ? <Clear /> : <Search />} </IconButton>,
									style: {
										borderRadius: "30px",
										height: "40px"
									}
								}}
							/><br />
							<div className="lists">
								{displayedbrands.map((brand, index) => (
									<label className="flex" key={brand.brand + index}>
										<input type="checkbox" onChange={(e) => brandFilterAction(brand.brand, e.target.checked)} />
										<span>{_.upperFirst(brand.brandName)}</span>
									</label>
								))}
								{displayedbrands.length === 0 && <label>~</label>}
							</div>
						</div>
						<div className="listing">
							<h4>Colors</h4>
							<div className="lists">
								{colors.map((color, index) => {
									return (
										<label className="flex" key={color.color + index}>
											<input type="checkbox" onChange={(e) => colorFilterAction(color.color, e.target.checked)} />
											<span>{_.upperFirst(color.colorName)}</span>
										</label>
									);
								})}
								{colors.length === 0 && <label>~</label>}
							</div>
						</div>
						<PriceRange
							onRequest={(min, max) => {
								setMinPriceRange(min);
								setMaxPriceRange(max);
							}}
						/>
						<SortBy onSorted={setSortBy} />
						{isMobile() &&
							<div>
								<h4>BEST SELLERS</h4><br />
								<div className='wraptopsellingcards' style={{ height: productsToView.length * 50 }} >
									{topSellingProducts?.map((val, key) => {
										return (
											<Topsellingcard product={val} key={key} />
										)
									})}
								</div>
							</div>}
					</div>
					<div className="right-side sections">
						{loading && <Loading />}
						{!loading && (!productsToView || productsToView.length == 0) && <p style={{ padding: '20px 10px' }}>Products Not Found</p>}
						{productsToView && (
							<>
								<div className="products-view">
									{productsToView.map((product, index) => {
										//console.log(product);
										return <Product data={product} key={index} />;
									})}
								</div>
								{productGroups.length > 1 && <PaginationBtn data={{ size: productGroups.length, position: viewGroupPosition, onChange: setViewGroupPosition }} />}
							</>
						)}
					</div>
				</div>
			}
		</div>
	);
}

export default React.memo(Category);
